import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '../api/api';

export default function Login() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    // Falls bereits eingeloggt, direkt zum Admin-Bereich
    if (api.isAuthenticated()) {
      navigate('/admin');
    }
  }, [navigate]);

  const handleLogin = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');
    
    try {
      const result = await api.login(username, password);
      if (result && result.token) {
        navigate('/admin');
      } else {
        throw new Error("Kein Zugriffstoken erhalten.");
      }
    } catch (err) {
      console.error("Login Fehler:", err);
      setError(err.message || 'Login fehlgeschlagen. Bitte prüfe deine Daten.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-100 flex items-center justify-center p-4 font-sans">
      <div className="max-w-md w-full bg-white rounded-[2rem] shadow-2xl overflow-hidden border border-slate-200">
        <div className="bg-black p-10 text-center">
          <h2 className="text-3xl font-black text-white tracking-tight">Login</h2>
          <p className="text-white/40 text-[10px] mt-2 uppercase tracking-[0.2em] font-bold">Administration</p>
        </div>
        
        <div className="p-10">
          <form className="space-y-6" onSubmit={handleLogin}>
            {error && (
              <div className="bg-red-50 text-red-600 p-4 rounded-2xl text-xs font-bold border border-red-100 text-center animate-bounce">
                {error}
              </div>
            )}
            
            <div className="space-y-2">
              <label className="block text-[10px] font-black text-slate-400 uppercase tracking-widest ml-1">Benutzername</label>
              <input 
                type="text" 
                required 
                autoFocus
                value={username} 
                onChange={(e) => setUsername(e.target.value)}
                className="w-full px-5 py-4 bg-slate-50 border border-slate-200 rounded-2xl focus:ring-2 focus:ring-black outline-none transition-all text-sm font-medium"
                placeholder="admin"
              />
            </div>

            <div className="space-y-2">
              <label className="block text-[10px] font-black text-slate-400 uppercase tracking-widest ml-1">Passwort</label>
              <input 
                type="password" 
                required 
                value={password} 
                onChange={(e) => setPassword(e.target.value)}
                className="w-full px-5 py-4 bg-slate-50 border border-slate-200 rounded-2xl focus:ring-2 focus:ring-black outline-none transition-all text-sm font-medium"
                placeholder="••••••••"
              />
            </div>

            <button 
              type="submit" 
              disabled={isLoading}
              className="w-full py-5 bg-black text-white rounded-2xl font-bold text-sm shadow-xl shadow-black/20 hover:bg-slate-800 transition-all active:scale-[0.98] disabled:opacity-50"
            >
              {isLoading ? 'Anmeldung läuft...' : 'Jetzt einloggen'}
            </button>
          </form>
          
          <div className="mt-10 text-center">
            <button 
              onClick={() => navigate('/')}
              className="text-xs font-bold text-slate-400 hover:text-black transition-colors flex items-center justify-center w-full"
            >
              ← Zurück zum Kalender
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}